import { Box, BoxProps, MaterialTextInput, TextInput } from '@jfs/ui-new'
import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import ShowHidePassword from './ShowHidePassword'
import { validateAadharNumber } from './validateAadhar'
interface AadharNumberEditTextProps {
  onTextChanged: (value: string, isValidAadhaar: boolean) => void
  label?: string
  error?: any
  type: 'NORMAL' | 'MATERIAL'
  rightSideComponent?: React.ReactNode
  initialVal?: string
}

const formatAadharNumber = (value: string) => {
  return value?.replace(/ /g, '').replace(/.{4}(?=.)/g, '$& ')
}

export const AadharNumberEditText: FC<AadharNumberEditTextProps> = (props: AadharNumberEditTextProps) => {
  const [aadharNumberText, setAadharNumberText] = useState(
    props?.initialVal?.replace(/ /g, '').replace(/.{4}(?=.)/g, '$& ') ?? '',
  )
  const [cursorPosition, setCursorPosition] = useState(0)
  const [errorMessage, setErrorMessage] = useState('')
  const [hidePassword, setHidePassword] = useState(true)

  useEffect(() => {
    setErrorMessage(props?.error ?? '')
  }, [props, props.error])

  const onValueChanged = (textValue: string) => {
    const isSpaceEntered = textValue.charAt(cursorPosition).trim() == ''

    textValue = formatAadharNumber(textValue)
    /*  const input = textValue.replace(/ /g, '')
    if (!isNaN(+input)) {
      const formattedAadhar = formatAadharNumber(input)
      setAadharNumberText(formattedAadhar)
      props.onTextChanged(formattedAadhar.replace(/ /g, ''), input.length === 12 ? validateAadharNumber(input) : false)
      if (input.length === 12 && !validateAadharNumber(input)) {
        setErrorMessage('Invalid Aadhar number')
      } else if (input.length === 12) {
        setErrorMessage('')
      }
    } */

    if (textValue.length > formatAadharNumber(aadharNumberText).length) {
      //user has typed something

      if (!isNaN(+textValue.charAt(cursorPosition))) {
        //user has typed some thing
        if (textValue.charAt(cursorPosition).trim()) {
          const finalAadhaarCardNo =
            aadharNumberText.slice(0, cursorPosition) +
            textValue.charAt(cursorPosition) +
            aadharNumberText.slice(cursorPosition)

          setAadharNumberText(formatAadharNumber(finalAadhaarCardNo))
          setCursorPosition(cursorPosition + 1)
          updateAadhaarNoPropsError(formatAadharNumber(finalAadhaarCardNo))
        } else if (!isNaN(+textValue.charAt(cursorPosition + 1))) {
          const finalAadhaarCardNo =
            aadharNumberText.slice(0, cursorPosition) +
            textValue.charAt(cursorPosition + 1) +
            aadharNumberText.slice(cursorPosition + 1)

          setAadharNumberText(formatAadharNumber(finalAadhaarCardNo))
          setCursorPosition(cursorPosition + 2)
          updateAadhaarNoPropsError(formatAadharNumber(finalAadhaarCardNo))
        } else {
          setTimeout(() => setCursorPosition(cursorPosition), 20)
        }
      } else {
        setTimeout(() => setCursorPosition(cursorPosition), 10)
      }
    } else if (textValue.length < formatAadharNumber(aadharNumberText).length) {
      //some thing has being deleted
      if (textValue.charAt(cursorPosition - 1) !== ' ') {
        //removing deleted char from aadharNumberText
        const finalAadhaarCardNo =
          aadharNumberText.slice(0, cursorPosition - 1) + aadharNumberText.slice(cursorPosition)
        setAadharNumberText(formatAadharNumber(finalAadhaarCardNo))
        updateAadhaarNoPropsError(formatAadharNumber(finalAadhaarCardNo))
      }
      setCursorPosition(cursorPosition - 1)
    } else {
      if (isSpaceEntered) {
        setTimeout(() => setCursorPosition(cursorPosition), 10)
      } else {
        setTimeout(() => setCursorPosition(cursorPosition - 1), 10)
      }
    }
  }

  const updateAadhaarNoPropsError = (aadharNum: any) => {
    aadharNum = aadharNum.replace(/ /g, '')
    props.onTextChanged(aadharNum, aadharNum.length === 12 ? validateAadharNumber(aadharNum) : false)
    if (aadharNum.length === 12 && !validateAadharNumber(aadharNum)) {
      setErrorMessage('Invalid Aadhar number')
    } else {
      setErrorMessage('')
    }
  }
  const validateAadhar = () => {
    const aadharNum = aadharNumberText.replace(/ /g, '').trim()
    if (aadharNum.length !== 12) {
      setErrorMessage('Aadhaar numbers should be 12 digit in length')
    } else if (!validateAadharNumber(aadharNum)) {
      setErrorMessage('Invalid Aadhar number')
    } else {
      setErrorMessage('')
    }
  }
  const isPasswordVisible = (isVisible: boolean): void => {
    setHidePassword(isVisible)
  }
  const onSelectionChange = (event: any) => {
    setCursorPosition(event?.nativeEvent?.selection?.end ?? 0)
  }

  const getMaskedAadhaarNumber = () => {
    if (aadharNumberText.length < 9) {
      return aadharNumberText.replace(/[0-9]/g, 'X')
    } else {
      return aadharNumberText.substring(0, 9).replace(/[0-9]/g, 'X') + aadharNumberText.substring(9)
    }
  }

  return (
    <Box bg="WHITE" {...styles.boxContainer}>
      {props.type === 'NORMAL' && (
        <TextInput
          type="h1Bold"
          testID="aadhaarcard-input"
          cursorPosition={cursorPosition}
          value={hidePassword ? getMaskedAadhaarNumber() : aadharNumberText}
          onChange={onValueChanged}
          placeholder={props?.label ?? ''}
          color={'PRIMARY_STORNG'}
          maxLength={14}
          placeholderTextColor={'BRAND_PRIMARY_WHITE'}
          error={errorMessage}
          keyboardType="numeric"
          onBlur={validateAadhar}
          onSelectionChange={onSelectionChange}
          bottomLineColor={'PRIMARY_STORNG'}
          fontSize={20}
          textAlign={'center'}
          fontFamily={'jioType-medium'}
          rightComponent={
            <ShowHidePassword
              isDisabled={false}
              isPasswordVisible={isPasswordVisible}
              showPassword={hidePassword}
              hide={aadharNumberText.length === 0}
            />
          }
          touched
        />
      )}
      {props.type === 'MATERIAL' && (
        <MaterialTextInput
          value={hidePassword ? getMaskedAadhaarNumber() : aadharNumberText}
          cursorPosition={cursorPosition}
          onChange={onValueChanged}
          testID="aadhaarcard-input"
          placeholder={props?.label ?? ''}
          color={'BLACK_21'}
          animatedColorValue="#DF9F39"
          tintColor="PRIMARY"
          maxLength={14}
          error={errorMessage}
          onBlur={validateAadhar}
          onSelectionChange={onSelectionChange}
          keyboardType="numeric"
          fontFamily={'jiotype-medium'}
          rightComponent={
            <>
              {props?.rightSideComponent}
              <ShowHidePassword
                isDisabled={false}
                isPasswordVisible={isPasswordVisible}
                showPassword={hidePassword}
                hide={aadharNumberText.length === 0}
              />
            </>
          }
          touched
        />
      )}
    </Box>
  )
}

const styles = {
  boxContainer: {
    height: 72,
    width: '100%',
    alignContent: 'center',
    alignItems: 'center',
  } as BoxProps,
}
